import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=6cca1596"
import script from "./Code.vue?vue&type=script&lang=ts"
export * from "./Code.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports